// Shared employee field options used by the admin employee forms.
// Kept in one place so Create and Edit stay in sync with the values the
// View screen (and the employee self-service profile) already display.

// Values are stored on Employee.blood_group as-is — do not change the value
// casing without migrating existing records.
export const BLOOD_GROUP_OPTIONS = [
  { value: "A+", label: "A RhD positive (A+)" },
  { value: "A-", label: "A RhD negative (A-)" },
  { value: "B+", label: "B RhD positive (B+)" },
  { value: "B-", label: "B RhD negative (B-)" },
  { value: "O+", label: "O RhD positive (O+)" },
  { value: "O-", label: "O RhD negative (O-)" },
  { value: "AB+", label: "AB RhD positive (AB+)" },
  { value: "AB-", label: "AB RhD negative (AB-)" },
];
